export interface GoogleMapsApiConfig {
	apiKey: string;
}

/**
 * Retrieves the google maps api key configuration from the environment variables.
 * @returns {GoogleMapsApiConfig} The api key
 * @throws {Error} If the google map api configuration is not set.
 */
export function loadGoogleMapsApiConfig(): GoogleMapsApiConfig {
	const { GOOGLE_MAPS_API_KEY } = process.env;

	if (!GOOGLE_MAPS_API_KEY) {
		throw new Error("GOOGLE_MAPS_API_KEY config is not set.");
	}

	return {
		apiKey: GOOGLE_MAPS_API_KEY
	};
}
